import React from 'react';

const HaveIdeaItem = () => {
    <>
    HaveIdeaItem
    </>
}

export default HaveIdeaItem;